var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TYPOGRAPHY_VARIANTS } from '../typography/typography';
export var getFormGroupStyles = function (theme) { return ({
    gap: theme.backrs.spacing['spacing-lg'],
}); };
export var getFormControlLabelStyles = function (theme, isSelected) { return (__assign(__assign({ display: 'flex', padding: theme.backrs.spacing['spacing-xl'], alignItems: 'flex-start', alignSelf: 'stretch', borderRadius: theme.backrs.radius['radius-xl'], outline: isSelected
        ? "2px solid ".concat(theme.backrs.colors['Brand/500'])
        : "1px solid ".concat(theme.backrs.colors['Colors/Border/border-primary']) }, TYPOGRAPHY_VARIANTS['text-md-regular']), { '& .MuiFormControlLabel-label': {
        margin: theme.backrs.spacing['spacing-none'],
    }, marginLeft: theme.backrs.spacing['spacing-none'], marginRight: theme.backrs.spacing['spacing-none'] })); };
export var getRadioStyles = function (theme, isSelected) { return ({
    padding: 0,
    marginRight: theme.backrs.spacing['spacing-lg'],
    '& .MuiSvgIcon-root': {
        width: '20px',
        height: '20px',
    },
    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)': {
        color: isSelected ? theme.backrs.colors['Colors/Base/Black'] : theme.backrs.colors['Gray/600'],
        borderRadius: theme.backrs.radius['radius-full'],
        backgroundColor: isSelected ? theme.backrs.colors['Brand/600'] : 'transparent',
        border: "1px solid ".concat(isSelected ? theme.backrs.colors['Colors/Base/Black'] : theme.backrs.colors['Gray/600']),
        '& path': {
            fill: isSelected ? theme.backrs.colors['Brand/600'] : 'transparent',
        },
    },
    '& .MuiSvgIcon-root + .MuiSvgIcon-root': {
        color: theme.backrs.colors['Colors/Base/White'],
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
}); };
export var getCheckboxStyles = function (theme) {
    var _a;
    return ({
        padding: 0,
        marginRight: theme.backrs.spacing['spacing-md'],
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
            borderRadius: theme.backrs.radius['radius-xs'],
            border: "1px solid ".concat(theme.backrs.colors['Colors/Base/Black']),
            backgroundColor: theme.backrs.colors['Brand/500'],
            color: theme.backrs.colors['Colors/Base/White'],
        },
        '&:not(.Mui-checked)': {
            '& .MuiSvgIcon-root': {
                backgroundColor: theme.backrs.colors['Colors/Base/White'],
                color: theme.backrs.colors['Colors/Base/Transparent'],
            },
        },
        '&.MuiCheckbox-root': {
            height: ((_a = theme.typography['text-md-regular']) === null || _a === void 0 ? void 0 : _a.lineHeight) || '1.5rem',
        },
        '&.Mui-disabled .MuiSvgIcon-root': {
            borderColor: theme.palette.action.disabled,
        },
    });
};
